import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteNameEnum } from '../../../enums/routeName';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import Notification from '../pages';
import NotificationDetail from '../pages/detail';
import CreateNotification from '../pages/create';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.notificationViewList],
    },
    routeProperties: {
      path: RouteNameEnum.notification.index,
      element: <Notification />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.notificationCreate],
      redirectUrl: RouteNameEnum.notification.index,
    },
    routeProperties: {
      path: RouteNameEnum.notification.create,
      element: <CreateNotification />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.notificationViewDetail],
      redirectUrl: RouteNameEnum.notification.index,
    },
    routeProperties: {
      path: RouteNameEnum.notification.detail,
      element: <NotificationDetail />,
    },
  },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      { routes.map((route) => (
        <Route
          key={route.routeProperties.path}
          element={<PrivateOutlet {...route.privateProperties} />}
        >
          <Route {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
